import React from "react";

import { WorkspacePlanTier } from "common/interfaces";
import FetchingClickShield from "js/react/components/FetchingClickShield";
import { browserHistory } from "js/react/history";
import { useExperiments } from "js/react/hooks/useExperiments";
import { useUser } from "js/react/hooks/useUser";

import ChoosePlanA, { trackAnalytics as trackAnalyticsA } from "./ChoosePlanA";
import ChoosePlanB from "./ChoosePlanB";

export default function ChoosePlan({
    onPlanSelected,
    onFinished,
    variant: variantSpecified
}: {
    onPlanSelected?: (plan: WorkspacePlanTier) => void;
    onFinished?: () => void;
    variant?: "A" | "B";
}) {
    const { user, loading: userLoading } = useUser();

    const {
        experiments: { checkout_pro_variant: isCheckoutProVariant, ai_onboarding_flow: isAiOnboardingFlow },
        loading: experimentsLoading
    } = useExperiments(["checkout_pro_variant", "ai_onboarding_flow"]);

    const variant = variantSpecified || (!isCheckoutProVariant && !isAiOnboardingFlow ? "A" : "B");

    const handlePlanSelected = async (plan: WorkspacePlanTier) => {
        if (variant === "A" && plan !== WorkspacePlanTier.ENTERPRISE && !user.get("didConfirmPlan") && !user.get("hasTakenTeamTrial")) {
            trackAnalyticsA(plan);
        }

        user.update({ didConfirmPlan: true });
        await user.updatePromise;

        if (onPlanSelected) {
            onPlanSelected(plan);
            return;
        }

        if (plan !== WorkspacePlanTier.BASIC) {
            setTimeout(() => {
                const continueUrl = window.location.pathname + window.location.search;
                const searchParams = new URLSearchParams();
                searchParams.set("plan", plan);
                searchParams.set("billingTerm", "year");
                searchParams.set("variant", variant);
                searchParams.set("continue", continueUrl);
                browserHistory.push("/checkout?" + searchParams.toString());
            }, 750);
            return;
        }

        if (onFinished) {
            onFinished();
        }
    };

    if (userLoading || experimentsLoading) {
        return <FetchingClickShield visible={true} backgroundColor="white" />;
    }

    return variant === "A"
        ? <ChoosePlanA handlePlanSelected={handlePlanSelected} />
        : <ChoosePlanB handlePlanSelected={handlePlanSelected} />;
}
